import React, { useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import PublicNavigation from '../navigation/PublicNavigation';

const PublicLayout: React.FC = () => {
  return (
    <>
      <PublicNavigation />
      <Outlet />
    </>
  );
};

export default PublicLayout;
